import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: 'rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05)',
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '4px',
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.3)',
        },
      },
    },
    variableCard: {
      height: '100%',
      borderRadius: '8px',
      transition: 'box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out',
      '&:hover': {
        boxShadow: '0 4px 12px rgba(0,0,0,0.12)',
        transform: 'translateY(-2px)'
      }
    },
    variableCardContent: {
      padding: theme.spacing(2),
    },
    variableCardTitle: {
      fontSize: '1rem',
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    variableValueContainer: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(1),
      borderRadius: '4px',
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      border: '1px solid rgba(0, 0, 0, 0.08)',
      maxHeight: '160px',
      overflowY: 'auto',
    },
    variableValue: {
      padding: theme.spacing(0.5, 1),
      borderRadius: '4px',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid rgba(0, 0, 0, 0.04)',
      fontFamily: 'monospace',
      fontSize: '0.8125rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minHeight: '32px',
      transition: 'all 0.2s ease',
      wordBreak: 'break-word',
      hyphens: 'auto',
      lineHeight: '1.3',
      '&:hover': {
        boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
        backgroundColor: theme.palette.background.default,
      }
    },
    actionButton: {
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      }
    },
    editButton: {
      '&:hover': {
        color: theme.palette.primary.main,
      }
    },
    deleteButton: {
      '&:hover': {
        color: theme.palette.error.main,
      }
    },
    emptyStateContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: theme.spacing(6, 3),
      borderRadius: '8px',
      backgroundColor: 'rgba(0, 0, 0, 0.02)',
      border: '1px dashed rgba(0, 0, 0, 0.2)',
    }
  };
});

export default useStyles;
